import {
  ClickAwayListener,
  Grow,
  MenuList,
  Paper,
  Popper,
} from '@mui/material';

type PopperMenuProps = {
  open: boolean;
  anchorEl: HTMLElement | null;
  onClose: (event: Event) => void;
  children: React.ReactNode;
};

export const PopperMenu = ({
  open,
  anchorEl,
  onClose,
  children,
}: PopperMenuProps) => (
  <Popper
    // Portalled to the body with a menu-level z-index, like every other MUI
    // menu. Rendered in place (`disablePortal`) it was clipped by any
    // `overflow: hidden` ancestor and outranked by anything painting above
    // zIndex 1 in the same stacking context - the rich-text editors do both,
    // and these menus are anchored right next to them.
    sx={{ zIndex: 'modal' }}
    open={open}
    anchorEl={anchorEl}
    role={undefined}
    transition
    placement="bottom-end"
  >
    {({ TransitionProps, placement }) => (
      <Grow
        {...TransitionProps}
        style={{
          transformOrigin:
            placement === 'bottom' ? 'center top' : 'center bottom',
        }}
      >
        <Paper>
          <ClickAwayListener onClickAway={onClose}>
            <MenuList dense autoFocusItem>
              {children}
            </MenuList>
          </ClickAwayListener>
        </Paper>
      </Grow>
    )}
  </Popper>
);
